export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LOGO =
  "https://customer-assets-agu9un31.emergentagent.net/job_981178e3-dc85-41ae-a6e8-852b8e182756/artifacts/erpda2aq_AAFF7FDE-A4C7-4710-88C2-1366BA0E34CF.png";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1559385301-0187cb6eff46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB5YWNodCUyMHdhdGVyfGVufDB8fHx8MTc4NjU2MTQ2MXww&ixlib=rb-4.1.0&q=85",
  hull:
    "https://images.unsplash.com/photo-1678122878190-b8a567929f6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjB5YWNodCUyMHdhdGVyfGVufDB8fHx8MTc4NjU2MTQ2MXww&ixlib=rb-4.1.0&q=85",
  deck:
    "https://images.unsplash.com/photo-1514480854622-ef7d8f2c572f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxib2F0JTIwY2xlYW5pbmclMjBwb2xpc2hpbmd8ZW58MHx8fHwxNzg2NTYxNDYwfDA&ixlib=rb-4.1.0&q=85",
  waxing:
    "https://images.unsplash.com/photo-1498528738175-10068e55f9a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxib2F0JTIwY2xlYW5pbmclMjBwb2xpc2hpbmd8ZW58MHx8fHwxNzg2NTYxNDYwfDA&ixlib=rb-4.1.0&q=85",
  location:
    "https://images.unsplash.com/photo-1706332287492-a5604d84a87a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxzYWx0JTIwbGFrZSUyMGNpdHklMjBtb3VudGFpbnMlMjB3YXRlcnxlbnwwfHx8fDE3ODY1NjE0NjB8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "hull-cleaning-detailing",
    num: "01",
    title: "Hull Cleaning & Detailing",
    image:
      "https://images.unsplash.com/photo-1568476612160-787b6a1d5fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzcGVlZGJvYXQlMjBwb3dlcmJvYXQlMjBvbiUyMHdhdGVyfGVufDB8fHx8MTc4NjU2NjE1Mnww&ixlib=rb-4.1.0&q=85",
    desc:
      "Precision below-the-waterline restoration. We strip growth, oxidation and grime, returning your hull to a mirror-clean, drag-free finish. For speed and power boats, a clean hull is free horsepower \u2014 less drag, more top-end, better fuel burn.",
    points: ["Below-waterline scrub", "Performance-hull prep for speed", "Oxidation removal", "Zinc & anode check"],
  },
  {
    id: "deck-interior-cleaning",
    num: "02",
    title: "Deck & Interior Cleaning",
    image: IMAGES.deck,
    desc:
      "From teak to upholstery, every surface is treated with marine-grade care. Salt, sunscreen and stains lifted from decks, cabins and helm without a trace.",
    points: ["Deck & non-skid", "Cabin & upholstery", "Glass & brightwork"],
  },
  {
    id: "waxing-polishing",
    num: "03",
    title: "Waxing & Polishing",
    image: IMAGES.waxing,
    desc:
      "A hand-applied, show-quality shine. Multi-stage cut and polish followed by a marine sealant that guards gelcoat against UV, salt and fading for months.",
    points: ["Multi-stage polish", "Ceramic / marine sealant", "UV protection"],
  },
  {
    id: "recurring-maintenance",
    num: "04",
    title: "Recurring Maintenance Plans",
    image: IMAGES.hero,
    desc:
      "Set it and forget it. Scheduled visits keep your vessel pristine season-round with priority booking, consistent crews and preferential members-only rates.",
    points: ["Weekly / monthly visits", "Priority scheduling", "Member pricing"],
  },
];

export const SLOGAN = "Protect what you\u2019ve earned";
export const PHONE = "(909) 493-4950";
export const PHONE_HREF = "tel:+19094934950";
export const SERVICE_AREA = "Salt Lake City, Utah & surrounding areas";
